/*
 * Copyright (C) 2021 Bosch.IO GmbH. All rights reserved.
 */

import React from 'react';
import styled from 'styled-components';
import { ReactChildren } from '../../types';
import cn from 'classnames';

const Bar = styled.div`
    height: 4rem;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    column-gap: 0.5rem;
`;

const Body = styled.div`
    flex-grow: 100;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
`;

const ContentArea = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 0.5rem;
`;

const ActionArea = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: 0.5rem;
`;

const MainAction = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`;

interface CommandBarProps extends React.HTMLAttributes<HTMLDivElement> {
    content?: ReactChildren;
    actions?: ReactChildren;
    mainAction?: React.ReactNode;
}

const CommandBar: React.FC<CommandBarProps> = ({
    content,
    actions,
    mainAction,
    className,
    ...props
}) => {
    return (
        <Bar {...props} className={cn(className, '-secondary')}>
            <Body>
                <ContentArea>{content}</ContentArea>
                <ActionArea>{actions}</ActionArea>
            </Body>
            <MainAction>{mainAction}</MainAction>
        </Bar>
    );
};

export { CommandBar, CommandBarProps };
